module.exports = __webpack_public_path__ + "r-v3/img/device-volume_off.f69956c4.svg";